import axios from "../../components/shared/axios"
import { actions } from "../pages"

const updatePreviewHtml = async (state, action, dispatch) => {
  if (!state.formRef) return
  const params = new FormData(state.formRef)
  const response = await axios.post(state.requestPreviewUrl, params)
  // console.log(response.data.html)
  dispatch({ type: actions.SET_HTML, payload: response.data.html })
}

export { updatePreviewHtml }
